import { createDefaultTyrann } from '@apis/common';
import { agencyBase, agencyListData, agency, fcAgencyGetQuery, agencyFc } from '@models/Agency';
import { staff } from '@models/Staff';
import * as t from 'io-ts';

export const agencyApis = createDefaultTyrann({
  '/dashboard/agency/': {
    get: {
      response: {
        200: t.array(agencyListData),
      },
    },
    post: {
      body: agencyBase,
      response: {
        200: agency,
      },
    },
  },
  '/dashboard/agency/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: agency,
      },
    },
  },
  '/dashboard/agency/{id}/staff/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.array(staff),
      },
    },
  },
  '/fc/agency/': {
    get: {
      query: fcAgencyGetQuery,
      response: {
        200: agencyFc,
        400: t.type({}),
      },
    },
  },
});
